import { render, staticRenderFns } from "./SubjectsTable.vue?vue&type=template&id=449fd61d&scoped=true"
import script from "./SubjectsTable.vue?vue&type=script&lang=js"
export * from "./SubjectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fd61d",
  null
  
)

export default component.exports